export default __webpack_public_path__ + "static/media/93.eb36f9b8.png";